module.exports = __webpack_public_path__ + "public/files/img/classroom-1.0b1ff039.png";